import { useGtmDataLayer } from '~/composables/gtm/useGtmDataLayer'

/**
 * GTM user tracking. Single composable returning tracking methods.
 */
export function useTrackUser() {
  const { dataLayer } = useGtmDataLayer()

  function trackUser(user) {
    if (import.meta.server || !user) {
      return
    }

    dataLayer?.push({ user_id: user })
  }

  function trackLogin(user) {
    if (import.meta.server || !user) {
      return
    }

    dataLayer?.push({ event: 'login', user_id: user })
  }

  function trackRegister(user) {
    if (import.meta.server) {
      return
    }

    dataLayer?.push({ event: 'sign_up', user_id: user })
  }

  return {
    trackUser,
    trackLogin,
    trackRegister,
  }
}
